import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const LetterDataQuery = gql`
  query ($domain: String!) {
    letterData(domain: $domain) {
      id
      title
      subject
      text
      attachmentInvoice
      attachmentProforma
      sendInvoiceToCustomer
      sendProformaToCustomer
      externalOrderState {
        id
        title
      }
      type
    }
    externalOrderStates {
      id
      title
      type
      priority
      color
      name
    }
    languages {
      id
      value
    }
  }
`;

const CreateLetterDataMutation = gql`
  mutation($letterData: CreateLetterDataInput!) {
    createLetterData(letterData: $letterData) {
      id
    }
  }
`;

const UpdateLetterDataMutation = gql`
  mutation($id: String!, $letterData: UpdateLetterDataInput!) {
    updateLetterData(id: $id, letterData: $letterData) {
      id
    }
  }
`;

const DeleteLetterDataMutation = gql`
  mutation($id: String!) {
    deleteLetterData(id: $id) {
      id
    }
  }
`;

interface IInputProps {
  children?: any;
  domain: string;
}

interface Response {
  data: any;
}

class GetLetterDataQuery extends React.Component<ChildProps<IInputProps, Response>, {}> {
  render() {
    const { letterData, createLetterData, updateLetterData, deleteLetterData }: any = this.props;
    return this.props.children({
      letterData,
      createLetterData,
      updateLetterData,
      deleteLetterData
    });
  }
}

export default compose(
  graphql<IInputProps, Response>(LetterDataQuery, {
    name: 'letterData'
  }),
  graphql<IInputProps, Response>(CreateLetterDataMutation, {
    name: 'createLetterData'
  }),
  graphql<IInputProps, Response>(UpdateLetterDataMutation, {
    name: 'updateLetterData'
  }),
  graphql<IInputProps, Response>(DeleteLetterDataMutation, {
    name: 'deleteLetterData'
  })
)(GetLetterDataQuery);



// WEBPACK FOOTER //
// ./src/components/Query/LetterData/LetterData.tsx